import { FormattedMessage } from 'react-intl';

import { VODCSSModules } from 'shared/utils/wix-connect';
import { getContentToShare } from 'widget/components/share-channel/share-channel';

import socialNetworkNames from 'widget/constants/social-networks';

import SocialShare from 'widget/player-widget/components/social-share/social-share';

import styles from 'widget/player-widget/components/player/info-overlay/share/share.styl';

import translations from '../../translations';


@VODCSSModules(styles)
export default class ShareChannel extends React.Component {

  static propTypes = {
    channelData: React.PropTypes.object,
    appSettings: React.PropTypes.object,
    onShare: React.PropTypes.func.isRequired,
  };

  render() {
    const { appSettings, channelData, onShare } = this.props;
    const networksClassNames = _.pick(styles, _.values(socialNetworkNames));
    const contentToShare = getContentToShare(channelData, appSettings);

    return (
      <div styleName="share-overlay"
           data-hook="shareChannelOverlay">
        <div styleName="title">
          <FormattedMessage {...translations.shareThisChannel} />
        </div>
        <SocialShare appSettings={appSettings}
                     networks={_.values(socialNetworkNames)}
                     content={contentToShare}
                     styleName="social-icons"
                     onShare={onShare}
                     buttonClassName={styles['share-icon']}
                     popoutOuterClassName={styles['popout-outer']}
                     popoutInnerClassName={styles['popout-inner']}
                     linkClassName={styles['share-link']}
                     networksClassNames={networksClassNames} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/share-channel/share-channel.js